export const numericOrNull = (v: unknown): number | null => {
  if (v === "" || v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const NUMERIC_SET_VALUE_AS = { setValueAs: numericOrNull };
